import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';

import { IMedia, SdHtmlComponent } from '@seb/web-design-system/core';

import { AbstractComponent } from '../abstract-component.component';
import { ComponentService, ImageService } from '../../../services';
import { TrimanComponentInterface } from '../../../models';

@Component({
  selector: 'wc-triman',
  templateUrl: './triman.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdHtmlComponent
  ]
})
export class TrimanComponent extends AbstractComponent<TrimanComponentInterface> implements OnInit {
  @Input() class = '';

  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, 'wc-component is-cms'].filter(Boolean).join(' ');
  }

  pictos: IMedia[];
  legalNotice: string;

  constructor(
    private componentService: ComponentService,
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryFunction = (cmp: TrimanComponentInterface): boolean => {
    return !!cmp.legalNotice;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.component$.pipe(
        this.componentService.reloadComponentForArrayProperties(['miniature'])
      ).subscribe((cmp: TrimanComponentInterface) => {
        this.pictos = Object.values(cmp.miniature || []).map((picto) => this.imageService.normalizeMedia(picto));
        this.legalNotice = cmp.legalNotice;

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
